import { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import LoadingOverlay from './components/LoadingOverlay';

// Performance: Code splitting com webpackChunkName e prefetch
// Rotas críticas (alta probabilidade de acesso) usam webpackPrefetch: true
// Reduz bundle inicial e melhora navegação subsequente

// Rotas de autenticação e principal (CRÍTICAS - prefetch habilitado)
const SignInPage = lazy(() => import(
  /* webpackChunkName: "signin" */
  /* webpackPrefetch: true */
  './pages/SignIn/index'
));

// Use DashboardRouter instead of direct MainDir
const DashboardRouterPage = lazy(() => import(
  /* webpackChunkName: "dashboard-router" */
  /* webpackPrefetch: true */
  './components/DashboardRouter'
));

// Rotas de cobrança (ALTA PRIORIDADE - prefetch habilitado)
const CobrarPage = lazy(() => import(
  /* webpackChunkName: "cobrar" */
  /* webpackPrefetch: true */
  './pages/CobrarPage'
));

const CobrarPageRouter = lazy(() => import(
  /* webpackChunkName: "cobrar-router" */
  /* webpackPrefetch: true */
  './components/CobrarPageRouter'
));

const ComissaoNelsonSemanas = lazy(() => import(
  /* webpackChunkName: "comissao-nelson-semanas" */
  './components/ComissaoNelsonPanel'
));

// Rotas de cobrança por feira (carregar sob demanda)
const CobrancaGravata = lazy(() => import(
  /* webpackChunkName: "cobranca-gravata" */
  './pages/CobrancaGravata'
));

// Rotas de gerenciamento (MÉDIA PRIORIDADE)
const RemoverBancasPage = lazy(() => import(
  /* webpackChunkName: "remover-bancas" */
  './pages/RemoverBancasPage'
));

const RemoverBancaRouter = lazy(() => import(
  /* webpackChunkName: "remover-banca-router" */
  './components/RemoverBancaRouter'
));

// Rotas de seleção de banca (carregar sob demanda)
const SelecaoBancaGravata = lazy(() => import(
  /* webpackChunkName: "selecao-gravata" */
  './pages/SelecaoBancaGravata'
));

const SelecaoBancaAreal = lazy(() => import(
  /* webpackChunkName: "selecao-areal" */
  './pages/SelecaoBancaAreal'
));

const SelecaoBancaRioDoce = lazy(() => import(
  /* webpackChunkName: "selecao-riodoce" */
  './pages/SelecaoBancaRioDoce'
));

const SelecaoBancaTabajara = lazy(() => import(
  /* webpackChunkName: "selecao-tabajara" */
  './pages/SelecaoBancaTabajara'
));

const SelecaoBancaMaranguape2 = lazy(() => import(
  /* webpackChunkName: "selecao-maranguape2" */
  './pages/SelecaoBancaMaranguape2'
));

// Rotas de visualização de cobrança (carregar sob demanda)
const VisualizarCobrancaGravata = lazy(() => import(
  /* webpackChunkName: "visualizar-gravata" */
  './pages/VisualizarCobrancaGravata'
));

const VisualizarCobrancaAreal = lazy(() => import(
  /* webpackChunkName: "visualizar-areal" */
  './pages/VisualizarCobrancaAreal'
));

const VisualizarCobrancaRioDoce = lazy(() => import(
  /* webpackChunkName: "visualizar-riodoce" */
  './pages/VisualizarCobrancaRioDoce'
));

const VisualizarCobrancaMaranguape2 = lazy(() => import(
  /* webpackChunkName: "visualizar-maranguape2" */
  './pages/VisualizarCobrancaMaranguape2'
));

const VisualizarCobrancaTabajara = lazy(() => import(
  /* webpackChunkName: "visualizar-tabajara" */
  './pages/VisualizarCobrancaTabajara'
));

// Rotas de busca e fiscalização (BAIXA PRIORIDADE)
const FiscalizarAreal = lazy(() => import(
  /* webpackChunkName: "fiscalizar-areal" */
  './pages/FiscalizarAreal'
));

const FiscalizarMaraguape2 = lazy(() => import(
  /* webpackChunkName: "fiscalizar-maranguape2" */
  './pages/FiscalizarMaraguape2'
));

const FiscalizarRioDoce = lazy(() => import(
  /* webpackChunkName: "fiscalizar-riodoce" */
  './pages/FiscalizarRioDoce'
));

const ImpressaoMapaRioDoce = lazy(() => import(
  /* webpackChunkName: "impressao-mapa-riodoce" */
  './pages/ImpressaoMapaRioDoce'
));

const ImpressaoMapaTabajara = lazy(() => import(
  /* webpackChunkName: "impressao-mapa-tabajara" */
  './pages/ImpressaoMapaTabajara'
));

const BuscaBancaEspecificaPage = lazy(() => import(
  /* webpackChunkName: "busca-banca-especifica" */
  './pages/BuscaBancaEspecificaPage'
));

const StyleguidePage = lazy(() => import(
  /* webpackChunkName: "styleguide" */
  './pages/StyleguidePage'
));

const NewStyleguidePage = lazy(() => import(
  /* webpackChunkName: "new-styleguide" */
  './pages/NewStyleguidePage'
));

const NewPreviewHub = lazy(() => import(
  /* webpackChunkName: "new-preview" */
  './pages/NewPreviewHub'
));

// --- Rebrand: telas New* apontadas nas rotas reais (grupos sem mapa) ---
// Troca de call sites aprovada pelo usuário (Fiscal + Relatórios/Comissão +
// Clientes/Usuários/Feiras + Cobrança sem mapa). Só ADITIVO: os imports/rotas
// antigos permanecem no arquivo; reverter é `git checkout -- src/routes.tsx`.
// Zona Protegida (mapas/Areal) NÃO é tocada — segue nas telas originais.
const GerenciarClientesNotaRouter = lazy(() => import('./components/GerenciarClientesNotaRouter'));
const GerenciarNotasRouter = lazy(() => import('./components/GerenciarNotasRouter'));
const NewFiscalDiretor = lazy(() => import('./pages/NewFiscalDiretor'));
const DistribuicoesFiscalRouter = lazy(() => import('./components/DistribuicoesFiscalRouter'));
const LocaisPrestacaoRouter = lazy(() => import('./components/LocaisPrestacaoRouter'));
const GerenciarPrestadorRouter = lazy(() => import('./components/GerenciarPrestadorRouter'));
const NewRelatoriosPage = lazy(() => import('./pages/NewRelatoriosPage'));
const NewRelatorioAgregado = lazy(() => import('./pages/NewRelatorioAgregado'));
const NewCriarRelatorio = lazy(() => import('./pages/NewCriarRelatorio'));
const NewVisualizarRelatorios = lazy(() => import('./pages/NewVisualizarRelatorios'));
const NewVisualizarRelatorio = lazy(() => import('./pages/NewVisualizarRelatorio'));
const ComissaoAdmRouter = lazy(() => import('./components/ComissaoAdmRouter'));
const ComissaoNelsonDetalheRouter = lazy(() => import('./components/ComissaoNelsonDetalheRouter'));
const NewPerfilPage = lazy(() => import('./pages/NewPerfilPage'));
const UsuariosLandingRouter = lazy(() => import('./components/UsuariosLandingRouter'));
const GerenciarUsuariosRouter = lazy(() => import('./components/GerenciarUsuariosRouter'));
const CadastrarUsuariosRouter = lazy(() => import('./components/CadastrarUsuariosRouter'));
const GerenciarFeirasRouter = lazy(() => import('./components/GerenciarFeirasRouter'));
const NewBuscarClientesPage = lazy(() => import('./pages/NewBuscarClientesPage'));
const EnderecosFeiraRouter = lazy(() => import('./components/EnderecosFeiraRouter'));
const NewSetCobrancaPage = lazy(() => import('./pages/NewSetCobrancaPage'));
const NewFinalizeCobrancaPage = lazy(() => import('./pages/NewFinalizeCobrancaPage'));
const NewCobrancasDiretor = lazy(() => import('./pages/NewCobrancasDiretor'));
const NewFiscalizarDiretor = lazy(() => import('./pages/NewFiscalizarDiretor'));
const NewBancasDiretor = lazy(() => import('./pages/NewBancasDiretor'));
const NewReceberAtrasadosDiretorPage = lazy(() => import('./pages/NewReceberAtrasadosDiretorPage'));

const ReceberAtrasadosPage = lazy(() => import(
  /* webpackChunkName: "receber-atrasados" */
  './pages/ReceberAtrasadosPage'
));

function MainRoutes() {
  return (
    <Suspense fallback={<LoadingOverlay isLoading={true} />}>
      <Routes>
        <Route path='/' element={<SignInPage />} />
        <Route path='/main' element={<DashboardRouterPage />} />
        <Route path='/create_cobranca' element={<NewSetCobrancaPage />} />
        <Route path='/finalize_cobranca' element={<NewFinalizeCobrancaPage />} />
        <Route path='/cobrancas' element={<NewCobrancasDiretor />} />
        <Route path='/fiscalizar' element={<NewFiscalizarDiretor />} />
        <Route path='/cobrar' element={<CobrarPage />} />
        <Route path='/gravata' element={<CobrancaGravata />} />
        <Route path='/cobrar/:regiaoId/:feiraId/:cobrancaId' element={<CobrarPageRouter />} />
        <Route path='/gerenciar_feiras' element={<GerenciarFeirasRouter />} />
        <Route path='/bancas' element={<NewBancasDiretor />} />
        <Route path='/new/receber_atrasados' element={<NewReceberAtrasadosDiretorPage />} />
        <Route path='/cadastrar_usuarios' element={<CadastrarUsuariosRouter />} />
        <Route path='/remover_bancas/:regiaoId/:feiraId' element={<RemoverBancasPage />} />
        <Route path='/visualizar_cobranca_gravata/:regiaoId/:feiraId/:cobrancaId' element={<VisualizarCobrancaGravata />} />
        <Route path='/visualizar_cobranca_areal/:regiaoId/:feiraId/:cobrancaId' element={<VisualizarCobrancaAreal />} />
        <Route path='/visualizar_cobranca_riodoce/:regiaoId/:feiraId/:cobrancaId' element={<VisualizarCobrancaRioDoce />} />
        <Route path='/visualizar_cobranca_maranguape2/:regiaoId/:feiraId/:cobrancaId' element={<VisualizarCobrancaMaranguape2 />} />
        <Route path='/visualizar_cobranca_tabajara/:regiaoId/:feiraId/:cobrancaId' element={<VisualizarCobrancaTabajara />} />
        <Route path='/selecao_banca_gravata/:regiaoId/:feiraId' element={<SelecaoBancaGravata />} />
        <Route path='/selecao_banca_areal/:regiaoId/:feiraId' element={<SelecaoBancaAreal />} />
        <Route path='/selecao_banca_riodoce/:regiaoId/:feiraId' element={<SelecaoBancaRioDoce />} />
        <Route path='/selecao_banca_tabajara/:regiaoId/:feiraId' element={<SelecaoBancaTabajara />} />
        <Route path='/selecao_banca_maranguape2/:regiaoId/:feiraId' element={<SelecaoBancaMaranguape2 />} />
        <Route path='/mapa_remover_banca/:regiaoId/:feiraId' element={<RemoverBancaRouter />} />
        <Route path='/relatorios' element={<NewRelatoriosPage />} />
        <Route path='/relatorios/agregado' element={<NewRelatorioAgregado />} />
        <Route path='/criar_relatorio' element={<NewCriarRelatorio />} />
        <Route path='/visualizar_relatorios' element={<NewVisualizarRelatorios />} />
        <Route path='/visualizar_relatorio/:id' element={<NewVisualizarRelatorio />} />
        <Route path='/buscar_clientes' element={<NewBuscarClientesPage />} />
        <Route path='/fiscal' element={<NewFiscalDiretor />} />
        <Route path='/fiscal/clientes' element={<GerenciarClientesNotaRouter />} />
        <Route path='/fiscal/notas' element={<GerenciarNotasRouter />} />
        <Route path='/fiscal/notas/geracao' element={<NewFiscalDiretor />} />
        <Route path='/fiscal/notas/distribuicoes' element={<DistribuicoesFiscalRouter />} />
        <Route path='/fiscal/notas/locais' element={<LocaisPrestacaoRouter />} />
        <Route path='/fiscal/notas/enderecos' element={<EnderecosFeiraRouter />} />
        <Route path='/fiscal/prestador' element={<GerenciarPrestadorRouter />} />
        <Route path='/fiscalizar_areal/:feiraId' element={<FiscalizarAreal />} />
        <Route path='/fiscalizar_riodoce/:feiraId' element={<FiscalizarRioDoce />} />
        <Route path='/fiscalizar_maranguape2/:feiraId' element={<FiscalizarMaraguape2 />} />
        <Route path='/comissao_nelson' element={<ComissaoNelsonSemanas />} />
        <Route path='/comissao_nelson/:semana' element={<ComissaoNelsonDetalheRouter />} />
        <Route path='/comissao_adm' element={<ComissaoAdmRouter />} />
        <Route path='/impressao_mapa_riodoce' element={<ImpressaoMapaRioDoce />} />
        <Route path='/impressao_mapa_tabajara' element={<ImpressaoMapaTabajara />} />
        <Route path='/busca_banca/:regiaoId/:feiraId' element={<BuscaBancaEspecificaPage />} />
        <Route path='/perfil' element={<NewPerfilPage />} />
        <Route path='/gerenciar_usuarios' element={<GerenciarUsuariosRouter />} />
        <Route path='/usuarios' element={<UsuariosLandingRouter />} />
        <Route path='/styleguide' element={<StyleguidePage />} />
        <Route path='/new-styleguide' element={<NewStyleguidePage />} />
        <Route path='/new-preview' element={<NewPreviewHub />} />
        <Route path='/new-preview/:slug' element={<NewPreviewHub />} />
        <Route path='/receber_atrasados' element={<ReceberAtrasadosPage />} />
      </Routes>
    </Suspense>
  );
}


export default MainRoutes;
